import AuthService from '@/modules/user/AuthService';
import UserApi from '@/modules/user/services/UserApi';
import User from '@/models/user/User';
import {I18N} from '@/services/enumTranslator/I18NDictionary';
import DictionaryStore from '@/commons/services/store/DictionaryStore';
import {NavigationGuardNext, Route} from 'vue-router';
import moment from 'moment/moment';
import Vue from 'vue';
import {CommonPrintoutQueryParams} from '@/components/calculator/printout/query-params/CommonPrintoutQueryParams';
import {SystemLanguage} from '@/services/enumTranslator/SystemLanguage';

export const PrintoutBeforeEnter = async({query,}: Route, from: Route, next: NavigationGuardNext) => {
  const queryParams: CommonPrintoutQueryParams = query as unknown as CommonPrintoutQueryParams;
  const isString = (value: any): value is string => typeof value === 'string';
  const ensureToken = async() => {
    if (!AuthService.token) {
      if (isString(queryParams.authToken)) {
        AuthService.token = queryParams.authToken;
      } else {
        console.error('authToken query is not valid', queryParams.authToken);
      }
    }
    const user = await UserApi.userInfo();
    AuthService.User = new User(user);
  };
  const isLanguageValid: boolean = isString(queryParams.lang) && Object.values<string>(SystemLanguage)
    .includes(queryParams.lang);
  if (isLanguageValid) {
    const language: SystemLanguage = query.lang as SystemLanguage;
    I18N.systemLanguage = language;
    moment.locale(language.toLocaleLowerCase());
    Vue.prototype.$vuetify.lang.current = language.toLocaleLowerCase();
  }
  await ensureToken();
  await DictionaryStore.fetchDictionary('bankDictionary');
  next();
};
